import Switch from "./Switch";
export default Switch;
export type { SwitchProps } from "./Switch";

